if (!customElements.get('nyvolt-yvolt-films')) {
  customElements.define('nyvolt-yvolt-films', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.videos = Array.from(this.querySelectorAll('video'));
      if ('IntersectionObserver' in window) {
        this.posterObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this.loadPoster(entry.target);
          this.posterObserver.unobserve(entry.target);
        }), {rootMargin:'250px 0px'});
      }
      this.videos.forEach(video => {
        if (this.posterObserver) this.posterObserver.observe(video);
        else this.loadPoster(video);
        video.addEventListener('play', () => this.videos.forEach(other => { if (other !== video) other.pause(); }));
      });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: 0 });
        this.videos.forEach(video => this.observer.observe(video));
      }
    }
    loadPoster(video) { if (video.dataset.poster) { video.poster = video.dataset.poster; delete video.dataset.poster; } }
    disconnectedCallback() { this.observer?.disconnect(); this.posterObserver?.disconnect(); }
  });
}
